import React from 'react';
import { ChevronDown } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
interface NavChild {
  title: string;
  url: string;
}
interface NavItem {
  title: string;
  url: string;
  children?: NavChild[];
}
const navLinks: NavItem[] = [{
  title: 'Programs',
  url: '/programs'
}, {
  title: 'Classes',
  url: '/classes',
  children: [{
    title: 'Taekwondo',
    url: '/classes/taekwondo'
  }, {
    title: 'Kickboxing',
    url: '/classes/kickboxing'
  }, {
    title: 'Homeschool',
    url: '/classes/homeschool'
  }, {
    title: 'Group & Corporate Self Defense Seminars',
    url: '/classes/self-defense-seminars'
  }, {
    title: 'Private Classes',
    url: '/classes/private-classes'
  }, {
    title: 'Our Classes Schedule',
    url: '/schedule'
  }, {
    title: 'Our Facility',
    url: '/facility'
  }]
}, {
  title: 'Benefits',
  url: '/benefits-for-children',
  children: [{
    title: 'Child Benefits',
    url: '/benefits-for-children'
  }, {
    title: 'Teen Benefits',
    url: '/benefits-for-teens'
  }, {
    title: 'Adult Benefits',
    url: '/benefits-for-adults'
  }, {
    title: 'Family Benefits',
    url: '/benefits-for-families'
  }, {
    title: 'Personal Safety',
    url: '/selfdefensetips'
  }]
}, {
  title: 'Midwest Cup 2026',
  url: '/midwest-cup-2026',
  children: [{
    title: 'Event Details',
    url: '/midwest-cup-2026'
  }, {
    title: 'Tournament Registration',
    url: '/midwest-cup-2026#registration'
  }]
}, {
  title: 'About',
  url: '/about'
}, {
  title: 'Forms',
  url: '/forms'
}, {
  title: 'Contact',
  url: '/contact'
}];
export function HomeNavDesktopMenu() {
  const location = useLocation();
  const currentPath = location.pathname;
  return <>
      {navLinks.map(link => <div key={link.title} className="relative group" data-id="element-1158">
          {link.children ? <>
              {link.url ? <Link to={link.url} className={`transition-colors font-medium text-sm uppercase tracking-wider flex items-center gap-1 ${link.children.some(child => child.url === currentPath) ? 'text-[#00D4FF]' : 'text-gray-300 hover:text-[#00D4FF]'}`} data-id="element-1159">
                  {link.title}
                  <ChevronDown className="w-4 h-4" data-id="element-1160" />
                </Link> : <span className={`transition-colors font-medium text-sm uppercase tracking-wider flex items-center gap-1 cursor-default ${link.children.some(child => child.url === currentPath) ? 'text-[#00D4FF]' : 'text-gray-300 hover:text-[#00D4FF]'}`} data-id="element-1161">
                  {link.title}
                  <ChevronDown className="w-4 h-4" data-id="element-1162" />
                </span>}
              {/* Dropdown Menu */}
              <div className="absolute top-full left-0 mt-2 w-48 bg-black/95 backdrop-blur-sm border border-gray-800 rounded-lg shadow-xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200" data-id="element-1163">
                {link.children.map(child => child.url ? <Link key={child.url} to={child.url} className={`block px-4 py-3 text-sm font-medium transition-colors ${currentPath === child.url ? 'text-[#00D4FF] bg-[#00D4FF]/10' : 'text-gray-300 hover:text-[#00D4FF] hover:bg-[#00D4FF]/5'}`} data-id="element-1164">
                      {child.title}
                    </Link> : <span key={child.title} className="block px-4 py-3 text-sm font-medium text-gray-500 cursor-default" data-id="element-1165">
                      {child.title}
                    </span>)}
              </div>
            </> : link.url ? <Link to={link.url} className={`transition-colors font-medium text-sm uppercase tracking-wider ${currentPath === link.url ? 'text-[#00D4FF]' : 'text-gray-300 hover:text-[#00D4FF]'}`} data-id="element-1166">
              {link.title}
            </Link> : <span className="font-medium text-sm uppercase tracking-wider text-gray-500 cursor-default" data-id="element-1167">
              {link.title}
            </span>}
        </div>)}
    </>;
}